var Endpoints = {
  "auth": {
    "login":
    /**
     * @return {string}
     */
    function login() {
      return "/api/auth/login";
    },
    "autologin":
    /**
     * @return {string}
     */
    function autologin() {
      return "/api/auth/autologin";
    },
    "password": {
      "request":
      /**
       * @return {string}
       */
      function request() {
        return "/api/password/request";
      },
      "change":
      /**
       * @return {string}
       */
      function change() {
        return "/api/password/change";
      }
    },
    "finalizeRegistration":
    /**
     * @return {string}
     */
    function finalizeRegistration() {
      return "/api/register/finalize";
    },
    "register":
    /**
     * @return {string}
     */
    function register() {
      return "/api/register";
    }
  },
  "blog": {
    "get":
    /**
     * @param id
     * @return {string}
     */
    function get(id) {
      if (arguments.length < 1) throw new Error();
      return "/api/blog" + (arguments.length ? "/" : "") + Array.prototype.slice.call(arguments).join('/');
    },
    "delete":
    /**
     * @param id
     * @return {string}
     */
    function _delete(id) {
      if (arguments.length < 1) throw new Error();
      return "/api/blog" + (arguments.length ? "/" : "") + Array.prototype.slice.call(arguments).join('/');
    },
    "save":
    /**
     * @param [id]
     * @return {string}
     */
    function save(id) {
      return "/api/blog" + (arguments.length ? "/" : "") + Array.prototype.slice.call(arguments).join('/');
    }
  },
  "comment": {
    "post":
    /**
     * @param streamId
     * @param replyId
     * @param sendAs
     * @return {string}
     */
    function post(streamId, replyId, sendAs) {
      if (arguments.length < 3) throw new Error();
      return "/api/comment" + (arguments.length ? "/" : "") + Array.prototype.slice.call(arguments).join('/');
    },
    "get":
    /**
     * @param streamId
     * @param commentId
     * @return {string}
     */
    function get(streamId, commentId) {
      if (arguments.length < 2) throw new Error();
      return "/api/comment" + (arguments.length ? "/" : "") + Array.prototype.slice.call(arguments).join('/');
    },
    "all":
    /**
     * @param streamId
     * @param page
     * @return {string}
     */
    function all(streamId, page) {
      if (arguments.length < 2) throw new Error();
      return "/api/comment/all" + (arguments.length ? "/" : "") + Array.prototype.slice.call(arguments).join('/');
    },
    "stream":
    /**
     * @param streamId
     * @return {string}
     */
    function stream(streamId) {
      if (arguments.length < 1) throw new Error();
      return "/api/comment/stream" + (arguments.length ? "/" : "") + Array.prototype.slice.call(arguments).join('/');
    },
    "moderate":
    /**
     * @param streamId
     * @param commentId
     * @param mode
     * @return {string}
     */
    function moderate(streamId, commentId, mode) {
      if (arguments.length < 3) throw new Error();
      return "/api/comment/moderate" + (arguments.length ? "/" : "") + Array.prototype.slice.call(arguments).join('/');
    },
    "self-moderate":
    /**
     * @param streamId
     * @param commentId
     * @return {string}
     */
    function selfModerate(streamId, commentId) {
      if (arguments.length < 2) throw new Error();
      return "/api/comment/self-moderate" + (arguments.length ? "/" : "") + Array.prototype.slice.call(arguments).join('/');
    }
  },
  "terms": {
    "get":
    /**
     * @return {string}
     */
    function get() {
      return "/api/terms";
    }
  },
  "topic": {
    "create":
    /**
     * @return {string}
     */
    function create() {
      return "/api/topic/create";
    }
  },
  "user": {
    "email": {
      "available":
      /**
       * @return {string}
       */
      function available() {
        return "/api/user/email";
      },
      "change":
      /**
       * @return {string}
       */
      function change() {
        return "/api/user/change-email";
      }
    },
    "nick": {
      "available":
      /**
       * @return {string}
       */
      function available() {
        return "/api/user/nick";
      }
    },
    "avatar": {
      "upload":
      /**
       * @return {string}
       */
      function upload() {
        return "/api/user/avatar";
      }
    },
    "suicide":
    /**
     * @return {string}
     */
    function suicide() {
      return "/api/user/suicide";
    },
    "addFavorite":
    /**
     * @param id
     * @return {string}
     */
    function addFavorite(id) {
      if (arguments.length < 1) throw new Error();
      return "/api/user/add-favorite" + (arguments.length ? "/" : "") + Array.prototype.slice.call(arguments).join('/');
    },
    "removeFavorite":
    /**
     * @param id
     * @return {string}
     */
    function removeFavorite(id) {
      if (arguments.length < 1) throw new Error();
      return "/api/user/remove-favorite" + (arguments.length ? "/" : "") + Array.prototype.slice.call(arguments).join('/');
    }
  }
};
export default Endpoints;